import React, { Component } from "react";
import { connect } from "react-redux";

import { createCompanyProfileType } from "actions/companyProfileType";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/CompanyProfileType/Form";

class CompanyProfileTypeCreate extends Component {
  handleFormSubmit = data => {
    this.createCompanyProfileType(data);
  };

  createCompanyProfileType(data) {
    const { toggleNotification, toggleFullPageSpinner, createCompanyProfileType, history } = this.props;
    toggleFullPageSpinner(true);
    createCompanyProfileType(data)
      .then(() => {
        toggleNotification(true, { message: "Created Company Profile Type Success", infoClassName: "is-success" });
        history.push(`/company-profile-types`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    return <Form handleFormSubmit={this.handleFormSubmit} />;
  }
}

export default connect(
  null,
  {
    createCompanyProfileType,
    toggleFullPageSpinner,
    toggleNotification
  }
)(CompanyProfileTypeCreate);



// WEBPACK FOOTER //
// ./src/pages/CompanyProfileType/Create/index.js